import React from 'react'
import LevelOne from '../../maxillofacial/mobile/LevelOne';

const MicroplatingSystem = () => {
	return (
		<LevelOne
			system={"microplatingSystem"}
		/>
	)
}

export default (MicroplatingSystem)